<template>
  <div class="modal-window large split active" id="print-contract">
    <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <form @submit.prevent="handleSubmit">
        <div class="grid-x split">
          <div class="cell large-6 flex-column">
            <div class="modal-window-header gray">
              <div class="modal-window-heading">
                <h3 class="icon-heading small">
                  <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg></span>
                  <span class="icon-heading-title">
                    <span class="title">Utleveringsseddel</span>
                  </span>
                </h3>
              </div>
            </div>

            <div class="modal-window-body">
              <fieldset>
                <div class="grid-x grid-padding-x">
                  <div class="cell">
                    <TheEmptyList :title="'Utleveringsseddel'" :message="'Trykk på Utlever for å generere utleveringsseddel'" :large="false" :icon="'button-glyph-contract'"/>
                  </div>
                </div>
              </fieldset>
            </div>

            <div class="modal-window-footer">
              <div class="grid-x">
                <div class="cell align-right">
                  <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
                  <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

                  <template v-if="!pdfSource">
                    <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Utlever</a>
                    <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Utlever...<span class="loader-spinner"></span></a>
                    <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Utlever</a>
                    <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="signObjekt()" class="button primary submit large">Signer</a>
                    <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Signer...<span class="loader-spinner"></span></a>
                    <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Signer</a>
                  </template>
                  <template v-else>
                    <a href="javascript:;" class="button primary submit large" disabled>Utlever</a>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="cell large-6 flex-column">
            <div class="modal-window-body no-padding">
              <div class="iframe-container pdf">
                <iframe v-if="pdfSource" id="pdfFrame" name="pdfFrame" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" :src="pdfSource + '#view=FitH&toolbar=1'"></iframe>
                <TheEmptyList v-if="!pdfSource && !$store.getters.isFormProcessing" :title="'Utleveringsseddel'" :message="'Trykk på Utlever for å generere utleveringsseddel'" :large="false" :icon="'button-glyph-contract'"/>
                <TheLoader :active="!pdfSource && $store.getters.isFormProcessing"/>
              </div>
            </div>
          </div>
        </div>

        <a v-if="!pdfSource" href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
        </a>
      </form>
    </overlay-scrollbars>
  </div>
</template>

<script>
import KundeService from '@/services/KundeService'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktCreateModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    kunde: {
      type: Object,
      required: false,
      default: null
    },
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      pdfSource: false
    }
  },
  created () {
    this.setFormLoading(false)
  },
  methods: {
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    },
    submitButtonClick: function () {
      this.printAndSendEmail = false

      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      let post = {
        items: this.items
      }

      const kundenr = this.kunde ? this.kunde.Kundenr || null : null
      KundeService.setDeliverableObjectsDelivered(kundenr, post)
        .then(response => {
          const url = process.env.VUE_APP_AVANTI_API_URL + response.data.file

          this.pdfSource = url

          bus.$emit('on-delivered-objects-done', response.data)
        })
        .catch(error => {
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke opprette PDF')
        })
        .then(() => {
          this.setFormProcessing(false)
        })
    },
    signObjekt: function () {
      this.openModal(
        'sign-objekt-modal',
        {
          items: this.items,
          kundenr: this.kunde.Kundenr
        },
        'split'
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/DeliverObjektModal.vue